<ion-header>
  <ion-toolbar>
    <ion-title>
      {{ !!transactionToAlter ? "Modifier" : "Ajouter" }}
      {{ isExpense ? "une dépense" : "un revenu" }}
    </ion-title>
    <ion-buttons slot="primary">
      <ion-button (click)="close()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-padding">
  <!-- Add stransaction form -->
  @if (addTransactionForm) {
    <form
      class="form"
      [formGroup]="addTransactionForm"
      (ngSubmit)="addTransaction()"
      >
      <ion-list class="list" lines="none">
        <!-- Amount definition -->
        <ion-item>
          <ion-input
            [errorText]="messages.required"
            label="Montant"
            labelPlacement="floating"
            type="number"
            inputmode="numeric"
            formControlName="amount"
            placeholder="34.16"
          ></ion-input>
        </ion-item>

        <!-- Label definition -->
        <ion-item>
          <ion-input
            [errorText]="messages.required"
            label="Libellé"
            labelPlacement="floating"
            type="text"
            inputmode="text"
            formControlName="label"
            placeholder="Courses ; Salaire ; Paiement de..."
          ></ion-input>
        </ion-item>

        <!-- Linked category definition -->
        <ion-item>
          <ion-select
            label="Catégorie"
            labelPlacement="floating"
            interface="popover"
            placeholder="Catégorie"
            formControlName="category"
            >
            @for (category of categories; track category) {
              <ion-select-option
                [value]="category.id"
                >
                {{ category.label }}
              </ion-select-option>
            }
          </ion-select>
        </ion-item>

        <!-- Devise selection -->
        <ion-item>
          <ion-select
            label="Devise"
            labelPlacement="floating"
            interface="popover"
            placeholder="Devise"
            formControlName="currency"
            >
            @for (currencyCode of currencies; track currencyCode) {
              <ion-select-option
                value="{{ currencyCode }}"
                >
                {{ currencyCode }}
              </ion-select-option>
            }
          </ion-select>
        </ion-item>

        <!-- Transaction date definition -->
        <div class="ion-text-center date-container">
          <ion-datetime-button datetime="datetime"></ion-datetime-button>

          <ion-modal [keepContentsMounted]="true">
            <ng-template>
              <ion-datetime
                [max]="todayDateString"
                [showDefaultButtons]="true"
                id="datetime"
                formControlName="date"
                presentation="date"
              ></ion-datetime>
            </ng-template>
          </ion-modal>
        </div>

        <div class="bottom-container">
          <!-- Submit button -->
          <ion-button
            type="submit"
            class="btn-validate-custom"
            color="dark"
            shape="round"
            [disabled]="addTransactionForm.invalid"
            >
            Valider
          </ion-button>
          <!-- Errors if any (server response) -->
          @if (addTransactionForm.hasError) {
            <ion-text class="form-input-invalid">{{
              addTransactionForm.errors?.serverError
            }}</ion-text>
          }
        </div>
      </ion-list>
    </form>
  }
</ion-content>
